<template>
    <div>
        <label class="d-block">Zusätzliche Empfänger</label>
        <b-table v-if="additionalRecipients.length > 0" ref="documentTable" :fields="header"
            :items="additionalRecipients">
            <template v-slot:cell(type)="rowData">
                <!--<b-form-select v-model="rowData.item.type" :options="types"/>-->
                <csp-form-select-searchable
                    class="col-12"
                    :options="types"
                    style="padding-left: 0;"
                    :value="rowData.item.type"
                    @change="setAdditionRecipientType($event, rowData.index)"/>
            </template>
            <template v-slot:cell(name)="rowData">
                <b-form-input v-model="rowData.item.name" :name="'additionalRecipientName' + rowData.index"/>
            </template>
            <template v-slot:cell(mail)="rowData">
                <b-form-input
                    v-model="rowData.item.mail"
                    autocomplete="email"
                    :name="'additionalRecipientMail' + rowData.index"
                    required/>
            </template>
            <template v-slot:cell(actions)="rowData">
                <b-button
                    size="sm"
                    variant="primary"
                    @click="removeRecipient(rowData.index)">
                    X
                </b-button>
            </template>
        </b-table>

        <b-button
            size="sm"
            variant="primary"
            @click="addAdditionalRecipient">
            Hinzufügen
        </b-button>
    </div>
</template>

<script>

    import SelectSearchable from '@components/form/SelectSearchable';

    export default {
        name: 'AdditionalMailRecipients',
        components: {
            'csp-form-select-searchable': SelectSearchable,
        },
        props: {
            form: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                additionalRecipients: [],
                types: [
                    {text: 'An', value: 'to'},
                    {text: 'Kopie', value: 'cc'},
                    {text: 'Blindkopie', value: 'bcc'},
                ],
                header: [
                    {key: 'type', label: 'Typ'},
                    {key: 'name', label: 'Name'},
                    {key: 'mail', label: 'Mail'},
                    {key: 'actions', label: '', class: 'text-right'},
                ],
            }
        },
        watch: {
            additionalRecipients: {
                handler(newVal) {
                    this.form.setData(newVal);
                },
                deep: true,
            },
        },
        created() {
            // apply additional recipients from template data
            const initialData = this.form.getData();
            if (Array.isArray(initialData) && initialData.length > 0) {
                this.additionalRecipients = initialData.map(recipient => ({
                    type: recipient.type || 'to',
                    name: recipient.name || '',
                    mail: recipient.mail || '',
                }));
            }
        },
        methods: {
            addAdditionalRecipient() {
                this.additionalRecipients.push({
                    type: 'to',
                    name: '',
                    mail: '',
                });
            },
            removeRecipient(index) {
                this.additionalRecipients.splice(index, 1);
            },
            setAdditionRecipientType(newType, index) {
                // item.type = newType.value;
                this.additionalRecipients[index].type = newType.value
            },
        },
    }
</script>
